import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-492c1dc3")

_pushScopeId("data-v-492c1dc3")
const _hoisted_1 = { class: "connected-layout" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_side_bar = _resolveComponent("side-bar")
  const _component_nav_bar = _resolveComponent("nav-bar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_side_bar),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_nav_bar),
      _createVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ])
  ]))
})